// import axios from 'axios';
import { ffetch as fetch, axios }  from '../customHttp';

// в данном файле реализованы базовые методы для работы с API

const lhosts = ['localhost', 'test.local'];
// получение URL сервера в зависимости от текущего хоста
// если хост совпадает с одним из локальных, то используется адрес разработки, иначе - относительный путь к API
// это позволяет использовать разные настройки для разработки и продакшена
const serverURL = `${process.env.REACT_APP_DEV_HOST_CORE}/`
console.log("SERVER URL", serverURL)
const FTSURL = `${process.env.REACT_APP_FTS_HOST}`
console.log("FTS URL", FTSURL)

// токен для авторизации в API
// он устанавливается при входе пользователя в систему и используется для авторизации всех запросов к API
let token;

// функция для установки токена
export function setToken($token) {
  token = $token;
}

// GET запрос к API 
export function get(url, data = {}, isText) {
  // формирование строки запроса из объекта data
  // ключи и значения объекта преобразуются в строку вида "ключ=значение"
  const dataStr = Object.keys(data)
    .filter((key) => data[key] !== null && data[key] !== undefined)
    .map((key) => `${key}=${typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key]}`)
    .join('&')
    .replace(/\+/g, '%2B');
    // отправка GET запроса к API с заголовками
  return fetch(`${serverURL}${url}?${dataStr}`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`, // notice the Bearer before your token
        // projectId,
      },
    })
    .then((res) => {
      if (res.status === 401) return { status: 401 };
      const v = isText ? res.text() : res.json()
      console.log('response', `${serverURL}${url}?${dataStr}`, v);
      return v;
    });
}

const fileCache = new Map();

function createFileKey(url, data) {
  const params = Object.entries(data)
    .filter(([, value]) => value !== null && value !== undefined)
    .sort(([a], [b]) => a.localeCompare(b));

  return JSON.stringify([url, params]);
}

export async function getFile(url, data = {}) {
  const cacheKey = createFileKey(url, data);

  // Уже загружается или был загружен
  if (fileCache.has(cacheKey)) {
    return fileCache.get(cacheKey);
  }

  const promise = loadFile(url, data);

  if (promise) {
    // Кладём Promise сразу
    fileCache.set(cacheKey, promise);

    try {
      return await promise;
    } catch (error) {
      // Если загрузка закончилась ошибкой,
      // удаляем из кэша, чтобы можно было повторить запрос
      fileCache.delete(cacheKey);

      return undefined;
    }
  }
  else {
    return undefined
  }
}

// метод получения пдф файла с сервера fts
export async function loadFile(url, data = {}) {
  try {
    
    const dataStr = Object.keys(data)
      .filter((key) => data[key] !== null && data[key] !== undefined)
      .map((key) => `${key}=${typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key]}`)
      .join('&')
      .replace(/\+/g, '%2B');

    let response = await axios.get(`${FTSURL}/getfile?${dataStr}`, {
      responseType: 'blob',
      Authorization: `Bearer ${token}`
    })
    if (response) {
      // создание объекта Blob из полученных данных
        // Blob - это объект, представляющий данные в виде двоичных данных
        // в данном случае мы получаем PDF файл
        // и создаем URL для его отображения или скачивания
        if (response.status === 401) return { status: 401 };
        console.log('response', `${serverURL}${url}?${dataStr}`, response);
        let content_type = undefined
        switch(url) {
          case "pdf":
            content_type = 'application/pdf'
            break
          case "png":
            content_type = 'image/png'
            break

        }
        const blob = new Blob([response.data], { type: content_type });
        return URL.createObjectURL(blob);
    } else return undefined
  }
  catch {
    return undefined
  }
}

// export function getFile(url, data = {}) {
//   try {
//     // тоже получение строки с параметрами
//     const dataStr = Object.keys(data)
//       .filter((key) => !!data[key])
//       .map((key) => `${key}=${typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key]}`)
//       .join('&')
//       .replace(/\+/g, '%2B');
//     return axios.get(`http://${FTSURL}:3050/getfile?${dataStr}`, {
//       responseType: 'blob',
//       Authorization: `Bearer ${token}`
//     })
//       .then(response => {
//         console.log('response0', `${serverURL}${url}?${dataStr}`, response);
//         // создание объекта Blob из полученных данных
//         // Blob - это объект, представляющий данные в виде двоичных данных
//         // в данном случае мы получаем PDF файл
//         // и создаем URL для его отображения или скачивания
//         if (response.status === 401) return { status: 401 };
//         console.log('response', `${serverURL}${url}?${dataStr}`, response);
//         let content_type = undefined
//         switch(url) {
//           case "pdf":
//             content_type = 'application/pdf'
//             break
//           case "png":
//             content_type = 'image/png'
//             break

//         }
//         const blob = new Blob([response.data], { type: content_type });
//         return URL.createObjectURL(blob);
//       })
//   }
//   catch {
//     return undefined
//   }
// }


// метод для получения данных с сервера fts
export function getFts(url, data = {}) {

  const dataStr = Object.keys(data)
    .filter((key) => data[key] !== null && data[key] !== undefined)
    .map((key) => `${key}=${typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key]}`)
    .join('&')
    .replace(/\+/g, '%2B');
    return fetch(`${FTSURL}${url}?${dataStr}`,
      {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`, // notice the Bearer before your token
        },
      })
    .then(response => {
      if (response.status === 401) return { status: 401 };
      const v = response.json();
      console.log('response', `${serverURL}${url}?${dataStr}`, v);
      return v;
    })
}

// патч запрос к API
export function patch(url, data, isText) {
  return fetch(`${serverURL}${url}`, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      Authorization: `Bearer ${token}`, // notice the Bearer before your token
    },
    body: JSON.stringify(data),
    method: 'PATCH',
  }).then((res) => (isText ? res.text() : res.json()));
}

// пост запрос к API
export function post(url, data, isText) {
  return fetch(`${serverURL}${url}`, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      Authorization: `Bearer ${token}`, // notice the Bearer before your token
    },
    body: JSON.stringify(data),
    method: 'post',
  }).then((res) => (isText ? res.text() : res.json()));
}

// метод для отправки файлов на сервер fts
// используется для загрузки файлов на сервер
// принимает массив файлов, идентификатор сессии сокета для получения статусу по файлу и дополнительную информацию
export function postPDF(files, sessionId, info) {
  console.log("files", files)
  console.log("sessionId", sessionId)
  console.log("info", info)
  // формируем объект FormData, который позволяет отправлять файлы на сервер
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append(`files[${i}]`, files[i]);
  }
  return axios.post(`${FTSURL}/uploadfile`, formData, {
    headers: {
      'X-Session-Id': sessionId,
      'Content-Type': 'multipart/form-data',
      'X-Metadata': JSON.stringify(info),
      Authorization: `Bearer ${token}`
    },
  });
}

// метод для отправки изображения на сервер fts
// используется для загрузки файлов на сервер
// принимает массив изображений, идентификатор сессии сокета для получения статусу по файлу и дополнительную информацию
export function postImage(files, sessionId, info) {
  console.log("files", files[0])
  console.log("sessionId", sessionId)
  console.log("info", info)
  // формируем объект FormData, который позволяет отправлять файлы на сервер
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append(`files[${i}]`, files[i]);
  }
  return axios.post(`${FTSURL}/uploadimage`, formData, {
    headers: {
      'X-Session-Id': sessionId,
      'Content-Type': 'multipart/form-data',
      'X-Metadata': JSON.stringify(info),
      Authorization: `Bearer ${token}`
    },
  });
}


// метод для удаления данных с сервера fts
export function delFts(url, data, sessionId) {
  return fetch(`${FTSURL}${url}`, {
    headers: {
      'X-Session-Id': sessionId,
      'Content-Type': 'application/json;charset=utf-8',
      Authorization: `Bearer ${token}`, // notice the Bearer before your token
    },
    body: JSON.stringify(data),
    method: 'delete',
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error("Ошибка удаления");
    }
    const text = await response.text();
    return text ? JSON.parse(text) : {};
  })
}

// метод для удаления данных с сервера API
export function del(url, data) {
  return fetch(`${serverURL}${url}`, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      Authorization: `Bearer ${token}`, // notice the Bearer before your token
    },
    body: JSON.stringify(data),
    method: 'delete',
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error("Ошибка удаления");
    }
    const text = await response.text();
    return text ? JSON.parse(text) : {};
  })
}

export function v2response(resp) {
  if (resp?.ver?.startsWith('2.')) {
    return resp.data;
  }
  return resp;
}
